import { SiteLink, SiteButton } from "@components/SiteClickable";
import * as React from 'react';
export default {
  SiteLink,
  SiteButton,
  React
};